// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ManOutlinedSvg from "@fishx/icons-svg/es/asn/ManOutlined";
import FishxIcon from '../components/FishxIcon';

var ManOutlined = function ManOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ManOutlinedSvg
  }));
};

ManOutlined.displayName = 'ManOutlined';
export default React.forwardRef(ManOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ManOutlined.js
// module id = 3085
// module chunks = 0